import styled from 'styled-components';

import { buttonFocusStyles } from '@rewardopl/react-ui/button/index.styles';

export const Wrapper = styled.div``;

export const List = styled.div`
  display: flex;
`;

export const Button = styled.button`
  min-height: 40px;
  margin: 0 -1px;
  padding: 6px 16px;
  background: none;
  border: 2px solid var(--primary);
  white-space: nowrap;
  color: var(--primary);
  font: inherit;
  font-size: 14px;
  font-weight: 700;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  cursor: pointer;

  &:hover {
    text-decoration: none;
    outline: none;
  }

  &:focus {
    ${buttonFocusStyles}
  }

  &[aria-selected='true'] {
    background-color: var(--primary);
    color: white;
  }
`;

export const ListItem = styled.div`
  &:first-child {
    ${Button} {
      border-top-left-radius: var(--border-radius-button);
      border-bottom-left-radius: var(--border-radius-button);
      margin-left: 0;
      padding-left: 22px;
    }
  }

  &:last-child {
    ${Button} {
      border-top-right-radius: var(--border-radius-button);
      border-bottom-right-radius: var(--border-radius-button);
      margin-right: 0;
      padding-right: 22px;
    }
  }
`;
